import { combineReducers } from 'redux';

import accountReducer from './features/account/reducer';
import funnelReducer from './features/funnel/reducer';
import payReducer from './features/pay/reducer';
import investmentsReducer from './features/investments/reducer';
import investorReducer from './features/investors/reducer';
import societyReducer from './features/society/reducer';
import toastReducer from './features/toasts/reducer';
import rolesReducer from './features/roles/reducer';

const rootReducer = combineReducers({
  account: accountReducer,
  funnel: funnelReducer,
  pay: payReducer,
  investments: investmentsReducer,
  investor: investorReducer,
  society: societyReducer,
  toasts: toastReducer,
  roles: rolesReducer,
})

export default rootReducer;
